export default {
  choose: {
    title: 'Fjern {{name}} som ejer',
    title_no_owner: 'Vælg en ejer til {{restaurant}}',
    description: 'Vælg, hvem der overtager efter {{name}}, eller lad {{restaurant}} være uden ejer for nu.',
    description_no_owner: '{{restaurant}} har ingen ejer. Vælg en fra teamet eller en ny person.',
    new_owner: 'Ny ejer',
    previous_owner: '{{name}} efter ændringen',
  },
  options: {
    team: {
      title: 'En fra teamet',
      loading: 'Henter teamet…',
      description_one: 'Enhver operatør eller medarbejder, {{count}} person.',
      description_other: 'Enhver operatør eller medarbejder, {{count}} personer.',
      empty: 'Der er ingen andre på teamet endnu.',
      search: 'Søg i teamet efter navn eller e-mail',
      no_match: 'Ingen på teamet matcher “{{query}}”.',
    },
    new: {
      title: 'En ny person',
      description: 'De bliver ejer med det samme og får deres login på e-mail.',
    },
    none: {
      title: 'Ingen ejer for nu',
      description: 'Vælg en ejer senere. Indtil da har {{restaurant}} ingen ejer.',
    },
    keep: {
      title: 'Bliver på teamet som operatør',
      description: 'Beholder adgang til de restauranter, de administrerer i dag.',
    },
    remove: {
      title: 'Fjernes fra teamet',
      description: 'Mister straks adgang til dashboardet.',
    },
  },
  roles: {
    operator: 'Operatør',
    employee: 'Medarbejder',
  },
  fields: {
    first_name: 'Fornavn',
    last_name: 'Efternavn',
    email: 'E-mail',
  },
  email_errors: {
    invalid_email: 'Angiv en gyldig e-mail, f.eks. navn@eksempel.dk.',
    email_is_owner: '{{name}} er allerede ejer.',
    email_is_manager: '{{name}} er allerede på teamet.',
    email_taken:
      'Der er allerede en person uden for dette team, som logger ind med denne e-mail. Brug en anden e-mail.',
  },
  confirm: {
    title: 'Fjern {{name}} som ejer?',
    title_no_owner: 'Gør {{name}} til ejer?',
    description_both: 'Begge ændringer sker samtidig. Hvis en fejler, ændres intet.',
    description: 'Tjek ændringen, før du bekræfter.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> har ingen ejer, før du vælger en. Alt, der kræver ejeren, venter til da.',
    new: '<b>{{name}}</b> bliver ejer af {{restaurant}} med det samme.',
    email: 'Deres login sendes til <b>{{email}}</b>. Tjek den: Den, der har denne e-mail, kan logge ind som ejer.',
    team: '<b>{{name}}</b> bliver ejer af {{restaurant}}.',
    group_access: 'Som ejer får de adgang til alle restauranter i {{group}}, hvilket kan være flere, end de har i dag.',
    keep: '<b>{{name}}</b> bliver på teamet som operatør.',
    remove: '<b>{{name}}</b> fjernes fra teamet og kan ikke længere logge ind.',
  },
  error: {
    title: 'Ejeren kunne ikke ændres.',
    description: 'Intet blev ændret. Prøv igen, eller kontakt support, hvis det bliver ved med at fejle.',
  },
  buttons: {
    close: 'Luk',
    continue: 'Fortsæt',
    cancel: 'Annuller',
    back: 'Tilbage',
    remove_as_owner: 'Fjern som ejer',
    make_owner: 'Gør til ejer',
    saving: 'Gemmer…',
    try_again: 'Prøv igen',
    choose_instead: 'Vælg {{name}} i stedet',
    invite_instead: 'Inviter en ny person i stedet',
  },
};
